import {Button} from "../index";
import React, {useMemo, useState} from "react";
import {
    walletConnectedImage,
    walletConnectImage,
    walletConnectingImage,
    walletErrorImage,
    walletSigningImage
} from "../../assets/wallet";
import {Lottie} from "../../ui";

export default function WalletModalContent({
                                               status,
                                               error,
                                               disconnect,
                                               setError,
                                               setVisible,
                                               visible,
                                               address,
                                               connected
                                           }: {
    status: string,
    error: string,
    disconnect: () => Promise<void>,
    setError: (error: string) => void,
    setVisible: (visible: boolean) => void,
    visible: boolean,
    address?: string,
    connected: boolean

}) {
    const pageData: {
        btnText?: string,
        btnLoading?: boolean,
        btnDisabled?: boolean,
        btnClick?: () => void
        statusImage: any
        text: string,
        isError?: boolean
    } = useMemo(() => {

        if (status == 'success') {
            return {
                btnText: 'Disconnect Wallet',
                btnClick: async () => {
                    await disconnect()
                },
                text: 'Wallet connection successful!',
                statusImage: walletConnectedImage
            }
        }
        if (status == 'error') {
            return {
                text: error,
                btnText: "Reconnect Wallet",
                btnClick: async () => {
                    console.log('click error')
                    setError('')
                    try {
                        await disconnect()
                    } catch (error: any) {
                        console.error(error)
                    }
                    setVisible(true)
                },
                statusImage: walletErrorImage,
                isError: true
            }
        }
        if (status == 'nonce') {
            return {
                btnLoading: true,
                text: 'Connecting',
                statusImage: walletConnectingImage
            }
        }
        if (status == 'signer') {
            return {
                btnLoading: true,
                text: 'Signing',
                statusImage: walletSigningImage
            }
        }
        if (visible) {
            return {
                btnLoading: true,
                text: 'Connecting',
                statusImage: walletConnectingImage,
            }
        }

        return {
            btnText: 'Connect Wallet',
            btnClick: () => {
                setVisible(true)
            },
            text: 'Please Connect your wallet',
            statusImage: walletConnectImage
        }
    }, [visible, connected, status, error, address])
    return <div className="matchid-wallet-container">
        <div className={`matchid-wallet-box`}>
            <div className={`matchid-wallet-content`}>
                <Lottie animationData={pageData.statusImage} style={{
                    width: 128,
                    height: 128
                }}/>
                <div className={pageData.isError ? 'matchid-error' : ''}>{pageData.text}</div>
            </div>
            <Button block size="lg" onClick={pageData.btnClick} loading={pageData.btnLoading}
                    disabled={pageData.btnDisabled}>
                {pageData.btnText}
            </Button>
        </div>
    </div>
}

export function WalletModalContentV2(props: {
    status: string,
    error?: string,
    onError?: () => Promise<void>,
    onConnect?: () => Promise<void>,
    onSuccess?: () => Promise<void>,
    onDisconnect?: () => Promise<void>,

}) {
    const [submitting, setSubmitting] = useState(false)
    const pageData: {
        btnText?: string,
        btnLoading?: boolean,
        btnDisabled?: boolean,
        btnClick?: () => Promise<void>
        statusImage: any
        text: string,
    } = useMemo(() => {
        const {status} = props
        if (status == 'success') {
            return {
                btnText: 'Disconnect Wallet',
                btnClick: async () => {
                    setSubmitting(true)
                    await props.onDisconnect?.()
                    setSubmitting(false)
                },
                text: 'Wallet connection successful!',
                statusImage: walletConnectedImage,
                btnLoading: submitting
            }
        }
        if (status == 'error') {
            return {
                text: props.error || 'Unknown Error',
                btnText: "Reconnect Wallet",
                btnClick: async () => {
                    setSubmitting(true)
                    await props.onError?.()
                    setSubmitting(false)
                },
                statusImage: walletErrorImage,
                isError: true,
                btnLoading: submitting
            }
        }
        if (status == 'nonce') {
            return {
                btnLoading: true,
                text: 'Connecting',
                statusImage: walletConnectingImage
            }
        }
        if (status == 'signer') {
            return {
                btnLoading: true,
                text: 'Signing',
                statusImage: walletSigningImage
            }
        }
        if (status == 'connecting') {
            return {
                btnLoading: true,
                text: 'Connecting',
                statusImage: walletConnectingImage,
            }
        }

        return {
            btnText: 'Connect Wallet',
            btnClick: async () => {
                setSubmitting(true)
                await props.onConnect?.()
                setSubmitting(false)
            },
            text: 'Please Connect your wallet',
            statusImage: walletConnectImage
        }
    }, [props, submitting])
    return <div className="matchid-wallet-container">
        <div className={`matchid-wallet-box`}>
            <div className={`matchid-wallet-content`}>
                <Lottie animationData={pageData.statusImage} style={{
                    width: 128,
                    height: 128
                }}/>
                <div className={props.status=='error' ? 'matchid-error' : ''}>{pageData.text}</div>
            </div>
            <Button block size="lg" onClick={pageData.btnClick} loading={pageData.btnLoading}
                    disabled={pageData.btnDisabled}>
                {pageData.btnText}
            </Button>
        </div>
    </div>
}